// PvtCompanyRegistration.jsx
import React from "react";

export default function PvtCompanyRegistration() {
  const handleWhatsAppClick = () => {
    const phoneNumber = "919217468906"; // without +
    const message =
      "Hello! I would like to get a consultation for Private Limited Company Registration.";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };

  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Private Limited Company
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Private Limited Company Registration in India
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks offers specialized assistance for Private
            Limited Company Registration, helping entrepreneurs and businesses
            set up a legally compliant corporate structure. Our team ensures
            adherence to MCA guidelines while facilitating a smooth and
            efficient incorporation process.
          </p>
          <p className="text-gray-700">
            From selecting an appropriate shareholding pattern to obtaining
            statutory approvals, every step is managed with professional
            precision so that you can focus on growing your business with
            confidence.
          </p>
        </div>

        {/* Right: Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/1560932/pexels-photo-1560932.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Team discussing private limited company registration"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Private Limited Company Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks supports the preparation, verification, and
              submission of all required documents, reducing delays and
              ensuring compliance at the time of incorporation.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>PAN card of all directors and shareholders</li>
                <li>Identity proof of directors (Aadhaar, Passport, etc.)</li>
                <li>Address proof of directors</li>
                <li>Proof of registered office address</li>
                <li>Recent passport-size photographs</li>
                <li>Digital Signature Certificate (DSC)</li>
                <li>Director Identification Number (DIN)</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm combines regulatory expertise with practical experience
              in private limited company setups, ensuring a streamlined and
              secure incorporation journey.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  In-depth Knowledge of Regulations
                </h3>
                <p className="text-gray-700 text-sm">
                  Detailed understanding of Companies Act provisions, MCA rules,
                  and compliance checkpoints specific to private limited
                  entities.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  End-to-End Incorporation Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Assistance from name reservation and drafting documents to
                  filing incorporation forms and obtaining the Certificate of
                  Incorporation.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate &amp; Timely Documentation
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise documentation handling, confidential data management,
                  and timely filing help avoid penalties and unnecessary
                  re-submissions.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <button
                type="button"
                onClick={handleWhatsAppClick}
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </button>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
